import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AiAgentService } from '../../../services/API/ai-agent.service';
import {
  AI_PAINEL_FECHA_ALEM_PX, AI_PAINEL_LARGURA_MIN_PX, AI_PAINEL_LARGURA_PX, AiLayoutService,
} from '../../../services/ai-layout.service';
import { OneResizeDirective } from '../../../directives/one-resize.directive';
import { OneIconButtonComponent } from '../../one-icon-button/one-icon-button.component';
import { AiConversaComponent } from '../ai-conversa/ai-conversa.component';

/**
 * Casca ACOPLADA do assistente (spec §4.2): coluna fixa à direita, abaixo do cabeçalho, que
 * EMPURRA o conteúdo via `--ai-painel-largura` (publicada pelo AiLayoutService). Sem scrim.
 * Só é montada quando `modoEfetivo() === 'painel'` — com tour ativo ou viewport estreita o
 * AiLayoutService rebaixa para 'chat' e o overlay assume (D8/D9).
 *
 * Task 5 (restyle §6.3): visual do sistema (glass), pega de resize (`OneResizeDirective`
 * delegando ao `AiLayoutService`), fonte contínua por CSS `clamp()` e estado "vai fechar"
 * quando o arrasto passa do piso menos a folga (`fechaAlem`).
 */
@Component({
  selector: 'ai-painel',
  standalone: true,
  imports: [OneIconButtonComponent, OneResizeDirective, AiConversaComponent],
  templateUrl: './ai-painel.component.html',
  styleUrl: './ai-painel.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AiPainelComponent {
  readonly svc = inject(AiAgentService);
  readonly layout = inject(AiLayoutService);

  readonly MIN = AI_PAINEL_LARGURA_MIN_PX;
  readonly MAX = AI_PAINEL_LARGURA_PX;
  readonly FECHA_ALEM = AI_PAINEL_FECHA_ALEM_PX;

  get accent(): string {
    return this.svc.corMarca() || 'var(--main-100, #109ccd)';
  }

  rotuloEstado(): string {
    switch (this.svc.estado()) {
      case 'ouvindo': return 'Ouvindo…';
      case 'pensando': return 'Pensando…';
      case 'falando': return 'Respondendo…';
      default: return 'Assistente';
    }
  }

  alternarMudo(): void { this.svc.mutado.set(!this.svc.mutado()); }
  desacoplar(): void { this.layout.definirModo('chat'); }
  telaCheia(): void { this.layout.definirModo('palco'); }
}
